export type VacationConfig = {
    // Base para el proporcional: 360 (año comercial de nómina) o 365 (días calendario)
    prorationBaseDays: 360 | 365;
    baseDaysPerYear: number;
    maxExtraDays: number;
    maxAccumulatedPeriods: number; // Art. 75
    // Días adicionales por antigüedad: "rest" = se gozan, "cash" = se pagan en dinero (decide el empleador, Art. 70)
    extraDaysMode: "rest" | "cash";
    // Art. 69: los 15 días incluyen los no laborables, así que un feriado dentro del período SÍ se descuenta.
    // Poner false si Wist decide dar el beneficio de no descontarlos.
    holidaysCountInContinuousPeriod: boolean;
};

export const VACATION_CONFIG: VacationConfig = {
    prorationBaseDays: 360,
    baseDaysPerYear: 15,
    maxExtraDays: 15,
    maxAccumulatedPeriods: 3,
    extraDaysMode: "rest",
    holidaysCountInContinuousPeriod: true,
};